import { down } from "styled-breakpoints";
import styled from "styled-components";

export const ActionSelectWrapper = styled.div`
  position: relative;
  display: inline-flex;

  .action-select-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    min-height: 44px;
    border: 0;
    border-radius: 999px;
    padding: 10px 18px;
    background: var(--color-primary);
    color: #fff;
    cursor: pointer;
    font-family: Halenoir, sans-serif;
    font-size: 14px;
    font-weight: 700;

    ${down("md")}{
      font-size: 12px;
      min-height: 32px;
    }
    &:focus-visible {
      outline: 3px solid rgb(6 157 25 / 28%);
      outline-offset: 3px;
    }

    svg {
      flex: 0 0 auto;
      margin-left: auto;
      transition: transform 160ms ease;
    }

    .action-select-label {
      display: inline-flex;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }

    &[aria-expanded="true"] svg {
      transform: rotate(180deg);
    }
  }

  .action-select-menu {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 1100;
    display: grid;
    min-width: 220px;
    padding: 7px;
    border: 1px solid #dce9df;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 16px 35px rgb(25 54 35 / 16%);
    overflow-y: auto;
  }

  .state-checkbox-menu {
    width: 220px;
    max-width: calc(100vw - 24px);
  }

  .state-checkbox-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 11px;
    border: 0;
    border-radius: 9px;
    background: transparent;
    color: #353d37;
    cursor: pointer;
    font-family: Halenoir, sans-serif;
    font-size: 13px;
    font-weight: 500;
    text-align: left;

    &:hover { background: #edf8ee; }

    input[type="checkbox"] {
      appearance: none;
      flex: 0 0 auto;
      width: 15px;
      height: 15px;
      margin: 0;
      border: 1px solid #8f9791;
      border-radius: 2px;
      background: #fff;
    }

    input[type="checkbox"]:checked {
      border-color: #079c16;
      background: #079c16;
      box-shadow: inset 0 0 0 3px #fff;
    }
  }

  /* Price trend menus are portalled to document.body, so their local menu
     styling lives here while remaining scoped to this page's selectors. */
  &.trend-select {
    .action-select-menu {
      border-color: #dce9df;
      background: #fff;
      box-shadow: 0 16px 35px rgb(25 54 35 / 16%);
    }

    .commodity-options {
      width: min(280px, calc(100vw - 24px));
      min-width: fit-content;
      max-height: 320px;
      overflow-x: hidden;
      box-sizing: border-box;
    }

    .commodity-options-list,
    .market-checkbox-list {
      display: grid;
      gap: 3px;
      min-width: 0;
    }

    .commodity-search-input {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin-bottom: 4px;
      padding: 9px 10px;
      border: 1px solid #dce9df;
      border-radius: 8px;
      background: #fff;
      color: #353d37;
      font-family: Halenoir, sans-serif;
      font-size: 12px;
      outline: none;
      box-sizing: border-box;

      &:focus { border-color: #079c16; }
      &::placeholder { color: #9aa19c; }
    }

    .commodity-search-empty {
      padding: 10px 11px;
      color: #7b837d;
      font-size: 12px;
    }

    .market-checkbox-option,
    .market-option,
    .market-state-option header label {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      color: #353d37;
      font-family: Halenoir, sans-serif;
      font-size: 13px;
      font-weight: 500;
    }

    .market-checkbox-option {
      padding: 10px 11px;
      border: 0;
      border-radius: 9px;
      background: transparent;
      text-align: left;
      cursor: pointer;

      &:hover { background: #edf8ee; }

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .market-checkbox-menu {
      width: 238px;
      max-height: 285px;
      padding: 7px;
    }

    .market-state-option {
      display: grid;
      gap: 4px;
      padding: 9px 10px;
      border-radius: 8px;

      &:first-child { background: #f1f8ef; }

      header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .market-option { padding: 7px 0 7px 19px; }

    .select-all-markets {
      padding: 6px 0 2px 19px;
      border: 0;
      background: transparent;
      color: #079c16;
      font-size: 11px;
      text-align: left;
      cursor: pointer;
    }

    input[type="checkbox"],
    input[type="radio"] {
      appearance: none;
      flex: 0 0 auto;
      width: 15px;
      height: 15px;
      margin: 0;
      border: 1px solid #8f9791;
      background: #fff;
    }

    input[type="checkbox"] { border-radius: 2px; }
    input[type="radio"] { border-radius: 50%; }

    input[type="checkbox"]:checked {
      border-color: #079c16;
      background: #079c16;
      box-shadow: inset 0 0 0 3px #fff;
    }

    input[type="radio"]:checked {
      border-color: #079c16;
      background: radial-gradient(circle, #079c16 0 4px, #fff 4.5px);
    }
  }

  &.business-produce-select {
    width: 100%;

    .action-select-trigger {
      width: 100%;
      min-height: 49px;
      padding: 12px 14px;
      border: 1px solid #cfd2d0;
      background: #fff;
      color: #292d32;
      font-weight: 400;
      text-align: left;
    }

    &.is-placeholder .action-select-trigger { color: #8f9491; }

    .action-select-menu {
      width: min(320px, calc(100vw - 24px));
      min-width: 0;
      border-color: #cfd2d0;
      border-radius: 16px;
      box-shadow: 0 12px 24px rgb(41 45 50 / 12%);
    }

    .market-checkbox-option {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 10px 11px;
      border: 0;
      border-radius: 9px;
      background: transparent;
      color: #292d32;
      font-family: Halenoir, sans-serif;
      font-size: 13px;
      text-align: left;
      cursor: pointer;

      &:hover { background: #edf8ee; }
    }

    input[type="checkbox"] {
      appearance: none;
      flex: 0 0 auto;
      width: 15px;
      height: 15px;
      margin: 0;
      border: 1px solid #8f9791;
      border-radius: 2px;
      background: #fff;
    }

    input[type="checkbox"]:checked {
      border-color: #079c16;
      background: #079c16;
      box-shadow: inset 0 0 0 3px #fff;
    }
  }

  .action-select-option {
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 9px;
    padding: 10px 11px;
    color: #23382b;
    font-family: Halenoir, sans-serif;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    width: 100%;
    border: 0;
    background: transparent;
    text-align: left;

    &:hover,
    &:focus-visible {
      background: #edf8ee;
      color: #087e18;
      outline: none;
    }

    svg {
      /* color: #087e18; */
    }
  }
`;
